{
  "en": {
    "published": {
      "labels": {
        "notPublished": "Not published",
        "publishedCustomer": "Published for customers",
        "publishedCustomerPartners": "Published for customers & partners",
        "publishedPartners": "Published for partners"
      },
      "publish_mode": {
        "inherit": "Follow template",
        "inherit_info": "Keep each item's published or unpublished state from the template"
      }
    }
  }
}
